<template>
    <div class="bulma">
        <div class="modal"
             :class="{ 'is-active': isShown }">
            <div class="modal-background" @click="closeModal"></div>
            <div class="modal-card">
                <header class="modal-card-head">
                    <svg class="modal-card-icon">
                        <use xlink:href="#icon-blog-settings"></use>
                    </svg>
                    <h2 class="modal-card-title">
                        {{ trans.modal_title.public_title }}
                    </h2>
                    <a
                        @click="closeModal"
                        :title="trans.buttons.close"
                    >
                        <svg class="close-modal">
                            <use xlink:href="#icon-cross"></use>
                        </svg>
                    </a>
                </header>
                <section class="modal-card-body">
                    {{ transText }}
                    <a v-if="baseBlogLink" class="base-blog-link" :href="baseBlogLink" target="_blank">
                        {{ baseBlogLink }}
                    </a>
                </section>
                <footer class="modal-card-foot">
                    <button
                        class="button"
                        @click="closeModal"
                    >
                        {{ trans.buttons.close }}
                    </button>
                </footer>
            </div>
        </div>
    </div>
</template>

<script>
import {mapActions, mapGetters} from "vuex";

export default {
    name: "BaseBlogUserNoRightsModal",
    computed: {
        ...mapGetters('baseBlogManager', {
            isShown: 'baseBlogUserNoRightsModalIsShown',
        }),
        ...mapGetters('baseBlogManager', [
            'trans',
            'baseBlogLink',
        ]),
        ...mapGetters('baseData', [
            'baseName',
        ]),
        transText() {
            if (this.baseBlogLink) {
                return this.trans.blog.manage.blog_link_label;
            } else {
                return this.replaceWildcards(this.trans.error.blog_not_exists, { baseName: this.baseName });
            }
        },
    },
    methods: {
        ...mapActions('baseBlogManager', {
            closeModal: 'hideBaseBlogUserNoRightsModal',
        }),
    },
}
</script>

<style lang="scss" scoped>
    @import 'resources/sass/variables.scss';

    .close-modal {
        width: 16px;
        height: 16px;
        fill: $white;
        &:hover {
            fill: $black;
        }
    }
</style>
